module.exports = __webpack_public_path__ + "img/symbol_5.9a02837b.png";